import React from 'react';
import cn from 'classnames';

import { zeroPad } from '../../util/functions';
import FitText from '../FitText';

import Card from '../Card';
import Text from '../Text';
import Image from '../Image';
import Share from '../Share';

import * as styles from './Intro.module.css';
import * as textStyles from '../../styles/text.module.css';

const Intro = ({
  number,
  title,
  slug,
  titleAddon,
  intro,
  sections,
  image,
  ...rest
}) => {
  const formattedIssueNumber = `(${zeroPad(number, 2)})`;

  const hasTitleAddon = !!titleAddon;

  return (
    <section className={cn(styles.root)} {...rest}>
      <FitText compressor={hasTitleAddon ? 1.25 : 0.95} maxFontSize={160}>
        <h1 className={cn(styles.title)}>
          <span className={cn(styles.titleNumber)}>{formattedIssueNumber}</span>
          {title}
          {titleAddon && (
            <span className={cn(styles.titleSmaller)}>({titleAddon})</span>
          )}
        </h1>
      </FitText>
      <Card tag="div" className={cn(styles.introCard)}>
        <div className={styles.coverImageWrapper}>
          <Image
            image={image}
            imgStyle={{ objectPosition: intro.imagePosition }}
            className={cn(styles.introCoverImage)}
          />
          <p className={styles.coverImageCaption}>{intro.imageCaption}</p>
        </div>

        <div className={cn(styles.introCardInner)}>
          <nav className={cn(styles.introNavigation)}>
            <ol>
              {sections.map(section => (
                <li key={section.id}>
                  <a
                    aria-current={section.active ? 'step' : null}
                    href={`#${section.id}`}
                  >
                    {section.label}
                  </a>
                </li>
              ))}
            </ol>
          </nav>
          <div className={cn(styles.introTextWrapper)}>
            <h3 className={cn(textStyles.headline, styles.introHeadline)}>
              {intro.headline}
            </h3>
            <Text className={cn(styles.introText)} text={intro.text} columns />
            {intro.imageCaption && (
              <p className={styles.coverImageCaptionMobile}>
                Imagen de portada: {intro.imageCaption}
              </p>
            )}
          </div>
        </div>
        <Share url={slug} className={cn(styles.share)} />
      </Card>
    </section>
  );
};

export default Intro;
